/**
 * Per-firm feature flags for firm-specific customisations.
 *
 * Partial payments: the firm can mark an invoice "Partly Paid" with a manual
 * amount, and the invoice list shows paid vs invoiced sums.
 */
const PARTIAL_PAYMENT_FIRM_IDS = [2];

export function firmHasPartialPayments(firms?: number[] | null): boolean {
  return (firms ?? []).some((id) => PARTIAL_PAYMENT_FIRM_IDS.includes(id));
}
